import { useContext } from "react";
import { Search, Filter } from "lucide-react";
import { VendasContext } from "../context/VendasContext";


const SELECT_BG = "bg-[url('data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%2371717a%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpolyline%20points%3D%226%209%2012%2015%2018%209%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E')] bg-no-repeat bg-[right_0.75rem_center]";


export default function ContainerFilters() {

    const { integrations } = useContext(VendasContext);
    const { search, setSearch } = useContext(VendasContext);
    const { startDateFilter, setStartDateFilter } = useContext(VendasContext);
    const { endDateFilter, setEndDateFilter } = useContext(VendasContext);
    const { statusFilter, setStatusFilter } = useContext(VendasContext);
    const { groupProductsFilter, setGroupProductsFilter } = useContext(VendasContext);
    const { groupProducts } = useContext(VendasContext);
    const { integrationFilter, setIntegrationFilter } = useContext(VendasContext);
    const { plataformFilter, setPlatformFilter } = useContext(VendasContext);


    return (
        <div className="surface-card p-4 mb-6 animate-slide-up">

            <div className="flex items-center gap-2 mb-4">
                <Filter className="h-4 w-4 text-brand-300" />
                <span className="label-overline">Filtros</span>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">

                <FieldWrap label="Buscar">
                    <div className="relative">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-ink-4 pointer-events-none" />
                        <input
                            type="text"
                            placeholder="Comprador ou produto..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="input-field !py-2 !text-sm pl-10"
                        />
                    </div>
                </FieldWrap>

                <FieldWrap label="Data inicial">
                    <input
                        type="date"
                        value={startDateFilter}
                        onChange={(e) => setStartDateFilter(e.target.value)}
                        className="input-field !py-2 !text-sm tabular-nums"
                    />
                </FieldWrap>

                <FieldWrap label="Data final">
                    <input
                        type="date"
                        value={endDateFilter}
                        onChange={(e) => setEndDateFilter(e.target.value)}
                        className="input-field !py-2 !text-sm tabular-nums"
                    />
                </FieldWrap>

                <FieldWrap label="Status de compra">
                    <select
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                        className={`input-field !py-2 !text-sm appearance-none cursor-pointer pr-9 ${SELECT_BG}`}
                    >
                        <option value="">Todos</option>
                        <option value="Aprovadas">Aprovadas</option>
                        <option value="Completadas">Completadas</option>
                        <option value="Reembolsadas">Reembolsadas</option>
                        <option value="Canceladas">Canceladas</option>
                        <option value="Todas as Não Compradas">Todas as Não Compradas</option>
                    </select>
                </FieldWrap>

                <FieldWrap label="Grupo de produtos">
                    <select
                        value={groupProductsFilter}
                        onChange={(e) => setGroupProductsFilter(e.target.value)}
                        className={`input-field !py-2 !text-sm appearance-none cursor-pointer pr-9 ${SELECT_BG}`}
                    >
                        <option value="">Todos</option>
                        {groupProducts.map(group => (
                            <option key={group.id} value={group.id}>{group.nome}</option>
                        ))}
                    </select>
                </FieldWrap>

                <FieldWrap label="Integração">
                    <select
                        value={integrationFilter}
                        onChange={(e) => setIntegrationFilter(e.target.value !== "" ? [e.target.value] : [])}
                        className={`input-field !py-2 !text-sm appearance-none cursor-pointer pr-9 ${SELECT_BG}`}
                    >
                        <option value="">Todos</option>
                        {integrations.map(integration => (
                            <option key={integration.id} value={integration.id}>{integration.nome}</option>
                        ))}
                    </select>
                </FieldWrap>

                <FieldWrap label="Plataforma">
                    <select
                        value={plataformFilter}
                        onChange={(e) => setPlatformFilter(e.target.value !== "" ? [e.target.value] : [])}
                        className={`input-field !py-2 !text-sm appearance-none cursor-pointer pr-9 ${SELECT_BG}`}
                    >
                        <option value="">Todas</option>
                        <option value="Hotmart">Hotmart</option>
                        <option value="Kiwify">Kiwify</option>
                        <option value="Lastlink">Lastlink</option>
                    </select>
                </FieldWrap>

            </div>
        </div>
    );
}


function FieldWrap({ label, children }) {
    return (
        <div className="space-y-1.5">
            <label className="text-2xs uppercase tracking-wider font-medium text-ink-4 block">{label}</label>
            {children}
        </div>
    );
}
